// src/pages/SignupPage.js
import React from 'react';
import Nav from '../components/nav/Nav';
import Footer from '../components/footer/Footer';
import Signup from '../components/auth/Signup';

function SignupPage() {
  return (
    <div className='page-content'>
      <Nav />
      <div className="signup-page-content page-container">
        <Signup />
      </div>
      <Footer />
    </div>
  );
}

export default SignupPage;
